import {
  BaseService,
  Status,
  DataResponse,
  MessageResponse,
  MessageData,
} from './base.service';
import { Hero } from '@/models/hero.model';

class HeroesService extends BaseService {
  private url: string = '/api/hero';

  constructor() {
    super();
  }

  public async get(id: number): Promise<DataResponse<Hero>> {
    const res = await this.$http.get<Hero>(`${this.url}/${id}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async getList(): Promise<DataResponse<Hero[]>> {
    const res = await this.$http.get<Hero[]>(`${this.url}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async create(item: Partial<Hero>): Promise<DataResponse<Hero>> {
    const res = await this.$http.post<Hero>(this.url, item);

    return {
      status: [Status.Ok, Status.Created].includes(res.status),
      data: res.data,
    };
  }

  public async edit(item: Hero): Promise<DataResponse<Hero>> {
    const res = await this.$http.put<Hero>(`${this.url}/${item.id}`, item);

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async delete(id: number): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(`${this.url}/${id}`);

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }
}

export default new HeroesService();
